/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  ADD_CLIENT_CHECKLIST_ANSWER,
  LOAD_CLIENT_CHECKLIST_ANSWER,
  LOAD_RECORDS_META_DATA,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadClientChecklistAnswer,
  loadClientChecklistAnswerSuccess,
  loadClientChecklistAnswerError,
  addClientChecklistAnswerSuccess,
  addClientChecklistAnswerError,
} from "./actions"

import {
  loadRecordsMetaData,
  loadChecklistAnswerDetails,
  addChecklistAnswerDetails,
} from "./remotes"

//Special Instructions
function* loadChecklistAnswerSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_CLIENT_CHECKLIST_ANSWER),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadClientChecklistAnswer(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadChecklistAnswerDetails, id)

        if (result) {
          yield put(loadClientChecklistAnswerSuccess(result.data))
        } else {
          yield put(loadClientChecklistAnswerError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadClientChecklistAnswerError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addChecklistAnswerSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_CLIENT_CHECKLIST_ANSWER),
    })
    const { checklistAnswer } = create || {}

    if (create) {
      console.log("records", checklistAnswer)
      try {
        yield call(addChecklistAnswerDetails, checklistAnswer)

        var successVal = addClientChecklistAnswerSuccess(
          checklistAnswer,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addClientChecklistAnswerError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const department = yield call(loadRecordsMetaData, "department", "post")
      const team = yield call(loadRecordsMetaData, "team", "post")

      let recordsMetaData = {
        departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        teamOptions:
          (team &&
            team.data &&
            team.data.length > 0 &&
            team.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.team, value: c._id })
              )) ||
          (team &&
            team.length > 0 &&
            team.map((c) =>
              Object.assign({}, { label: c.team, value: c._id })
            )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadChecklistAnswerSaga(),
    addChecklistAnswerSaga(),
  ])
}
